<template>
  <div class="rossetto-menu">
    <global-navigation-top :last-route="lastRoute" :open="open" />

    <ul
      class="rossetto-menu__full__list"
      :class="{'rossetto-menu__full__list--active': open }">
      <li>
        <span>01</span> <router-link :to="{ name: 'home' }">Il laboratorio</router-link>
      </li>
      <li>
        <span>02</span> <router-link :to="{ name: 'services' }">Servizi</router-link>
      </li>
      <li>
        <span>03</span> <router-link :to="{ name: 'solutions' }">Soluzioni</router-link>
      </li>
      <li>
        <span>04</span> <router-link :to="{ name: 'company' }">Ricerca e sviluppo</router-link>
      </li>
      <li>
        <span>05</span> <router-link :to="{ name: 'greenSpirit' }">Sistema di qualità</router-link>
      </li>
    </ul>

    <ul
      class="rossetto-menu__aux"
      :class="{'rossetto-menu__aux--active': open }">
      <li>
        <router-link :to="{ name: 'info-contacts' }">Contatti</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'job-contacts' }">Lavora con noi</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'info-contacts' }">Tel. +39 0422 815518</router-link>
      </li>
    </ul>

    <div class="rossetto-menu__aside" :class="{'rossetto-menu__aside--active': open }">
      <ul class="articles-list--left">
        <li
          v-for="article of leftList"
          :key="article.slug"
          @click="$router.push({ name: 'article', params: { slug: article.slug } })">
          <div
            class="articles-list__image"
            :style="{ backgroundImage: `url(${apiUrl}${cover(article.cover.data.id)})` }"></div>
          <div class="articles-list__title">{{ article.title }}</div>
        </li>
      </ul>
      <ul class="articles-list--right">
        <li
          v-for="article of rightList"
          :key="article.slug"
          @click="$router.push({ name: 'article', params: { slug: article.slug } })">
          <div
            class="articles-list__image"
            :style="{ backgroundImage: `url(${apiUrl}${cover(article.cover.data.id)})` }"></div>
          <div class="articles-list__title">{{ article.title }}</div>
        </li>
      </ul>
      <ul class="articles-list--mobile">
        <li
          v-for="article of list"
          :key="article.slug"
          @click="$router.push({ name: 'article', params: { slug: article.slug } })">
          <div
            class="articles-list__image"
            :style="{ backgroundImage: `url(${apiUrl}${cover(article.cover.data.id)})` }"></div>
          <div class="articles-list__title">{{ article.title }}</div>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import SiteLogo from './../components/SiteLogo'
import GlobalNavigationTop from './../components/GlobalNavigationTop'

export default {
  components: {
    SiteLogo,
    GlobalNavigationTop
  },
  data: () => ({
    open: false,
    lastRoute: {
      name: 'landing'
    }
  }),
  computed: {
    ...mapGetters('articles', [
      'list',
      'cover'
    ]),
    leftList: {
      get () {
        return _.reduce(this.list, (leftList, value, key) => {
          if (key % 2 === 0) return _.concat(leftList, value)
          return leftList
        }, [])
      }
    },
    rightList: {
      get () {
        return _.reduce(this.list, (leftList, value, key) => {
          if (key % 2 !== 0) return _.concat(leftList, value)
          return leftList
        }, [])
      }
    },
    routeName: {
      get () {
        return this.$route.name
      }
    },
    apiUrl: {
      get () {
        return _.trim(process.env.VUE_APP_BACKEND_URL, '/')
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getArticles()
      vm.$data.lastRoute = from || { name: 'landing' }
      vm.$data.open = true
    })
  },
  beforeRouteLeave (to, from, next) {
    this.open = false
    next()
  },
  methods: {
    ...mapActions('articles', [
      'getArticles',
      'getCover'
    ])
  },
  watch: {
    list: {
      handler (list) {
        _.forEach(list, ({ cover }) => {
          this.getCover(cover.data.id)
        })
      }
    }
  }
}
</script>

<style lang="scss">

@import '../assets/scss/breakpoint.scss';

$purple: #E30045;
$white: #f2f2f2;
$marginLeftRight: 6.25%;
$marginLeftRightDesktop: 3.25%;
$marginLeftRightBig: 15%;
$marginTop: 5%;
$white: #f2f2f2;

.rossetto-menu .global-navigation__top{
  position: fixed;

  @include media("<medium"){
    &{
      justify-content: flex-end;
    }
    .siteLogo{
      display: none;
    }
    .rossetto-menu__navigation__button__extra-text{
      display: none;
    }
    .menu__button__bar, .menu__button__bar--bottom {
      content: '';
      position: absolute;
      height: 2px;
      width: 100%;
      top: 50%;
      left: 0;
      margin-top: -1px;
      background: white;
    }
    .menu__button__bar{
      transform: rotate(45deg);
    }
    .menu__button__bar--bottom {
      transform: rotate(-45deg);
    }

  }
  @include media(">=medium"){
    position: relative;
    background-color: transparent;
  }
}

.rossetto-menu .global-navigation__menu__button{
  min-height: 2px;
}

.rossetto-menu{
  position: absolute;
  box-sizing: border-box;
  background: #0a2f75;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-height: 100vh;
  top: 0;
  z-index: 200;
}

.rossetto-menu__navigation__button__extra-text{
  font-size: 1.6rem;
  text-decoration: none;
  color: white;

  @include media(">=large"){
    color: #0a2f75;
  }

  @include media(">=xlarge"){
    font-size: 1.8rem;
  }
}
.rossetto-menu .menu__button__bar{
  background: white;
  @include media(">=large"){
    background: #0a2f75;
  }
}

.rossetto-menu__navigation {
  position: absolute;
  z-index: 2;
  display: flex;
  width: 30px;
  height: 50px;
  align-items: center;
}

.rossetto-menu__full__list {
  box-sizing: border-box;
  display: block;
  padding: 5rem $marginLeftRight 5rem;
  opacity: 0;
  width: 100%;
  margin: 0;
  list-style: none;
  @include media(">=medium"){
    padding: 5rem $marginLeftRight 10rem;
  }
  @include media(">=large"){
    width: 50%;
    padding: 0 $marginLeftRightDesktop 0;
  }
}

.rossetto-menu .rossetto-menu__full__list{
  @include media("<medium"){
    margin-top: 50px;
  }
}

.rossetto-menu__full__list li:not(:last-child){
  margin-bottom: 1.5rem;
}

.rossetto-menu__full__list--active {
  opacity: 1;
  transition: opacity .5s .8s;
}

.rossetto-menu__full__list a{
  position: relative;
  color: white;
  text-decoration: none;
  font-size: 2.5rem;
  line-height: 1.5;
  &:after{
    display: block;
    content: "";
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 2px;
    background: white;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform .3s ease-out;
    @include media("<large"){
      bottom: -2px;
    }
  }
  &:hover{
    &:after{
      transform: scaleX(1);
      transform-origin: left;
    }
  }
  @include media(">=medium"){
    font-size: 4.5rem;
  }
  @include media(">=large"){
    display: inline-block;
  }
  @include media(">=xlarge"){
    font-size: 6rem;
  }
}
.rossetto-menu__full__list span{
  display: none;
  font-size: 1.2rem;
  margin-right: 5%;
  color: white;
  @include media(">=large"){
    display: inline-block;
    font-size: 1.5rem;
    margin-right: 5%;
  }
}
.rossetto-menu__aux {
  background: #0a2f75;
  opacity: 0;
  padding: 0 $marginLeftRight 5rem;
  margin: 0;
  box-sizing: border-box;
  width: 100%;
  list-style: none;
  @include media(">=large"){
    align-self: flex-end;
    padding: $marginLeftRightDesktop 3.25% $marginLeftRightDesktop;
  }
  @include media(">=xlarge"){
    padding: $marginLeftRightDesktop 14% $marginLeftRightDesktop;
  }
}

.rossetto-menu__aux--active {
  opacity: 1;
  transition: opacity .5s 1.3s;
}

.rossetto-menu__aux li{
  margin-bottom: 1rem;
  @include media(">=medium"){
    margin-bottom: 0;
    display: inline-block;
    &:not(:last-child){
      margin-right: 2rem;
    }
  }
}
.rossetto-menu__aux a{
  position: relative;
  color: white;
  text-decoration: none;
  font-size: 1.6rem;
  display: inline-block;
  &:after{
    display: block;
    content: "";
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1px;
    background: white;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform .3s ease-out;
  }
  &:hover{
    &:after{
      transform: scaleX(1);
      transform-origin: left;
    }
  }
  @include media(">=xlarge"){
      font-size: 1.8rem;
  }
}
.rossetto-menu__aside {
  background-color: #f4f4f4;
  position: relative;
  display: flex;
  margin: 0;
  padding: calc(#{$marginLeftRight} + 10px) $marginLeftRight;
  box-sizing: border-box;
  width: 100%;
  align-self: flex-end;
  opacity: 0;
  transition: opacity .5s 1.3s;

  &.rossetto-menu__aside--active {
    opacity: 1;
  }

  @include media(">=large"){
    height: 100vh;
    overflow-y: scroll;
    padding: $marginLeftRightDesktop $marginLeftRight;
  }
  @include media(">=large"){
    position: absolute;
    right: 0;
    top: 0;
    width: 50%;
    height: 100%;
    padding-right: $marginLeftRightDesktop;
    align-items: flex-end;
    justify-content: flex-end;
  }

  .articles-list--left, .articles-list--right, .articles-list--mobile {
    list-style: none;
    margin: 0;
    position: absolute;
    padding: 30px 50px 90px 50px;
    top: 0;
    width: 50%;
    box-sizing: border-box;
    background-color: #f4f4f4;

    li {
      background-color: white;
      width: 100%;
      display: inline-block;
      vertical-align: top;
      color: #0a2f74;
      font-size: 2.8rem;
      line-height: 44px;
      box-sizing: border-box;
      margin-top: 60px;
      transition: transform .3s ease-in-out;
      cursor: pointer;

      &:hover {
        transform: scale(1.05);
        box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
      }

      @include media(">=large") {
        font-size: 2rem;
      }

      @include media(">=xlarge") {
        font-size: 2.4rem;
      }
    }

    .articles-list__image {
      width: 100%;
      height: 0;
      padding-bottom: 100%;
      background-size: cover;
    }

    .articles-list__title {
      line-height: 40px;
      right: 0;
      padding: 40px 20px;
    }
  }

  .articles-list--left {
    left: 0;
    padding-right: 20px;
    display: none;
    padding-bottom: 240px;

    @include media(">=medium") {
      display: block;
    }
  }

  .articles-list--right {
    right: 0;
    padding-top: 180px;
    padding-left: 20px;
    display: none;

    @include media(">=medium") {
      display: block;
    }
  }

  .articles-list--mobile {
    position: relative;
    padding: 0;
    width: 100%;

    @include media(">=medium") {
      display: none;
    }
  }
}

.rossetto-menu__aside__social--active {
  opacity: 1;
  transition: opacity .5s 1.8s;
}

.rossetto-menu__aside__social {
  opacity: 0;
  list-style: none;
  margin: 0;
  padding: 0;
  @include media(">=large"){
    transform: rotate(180deg);
  }
}

.rossetto-menu__aside__social--active {
  opacity: 1;
  transition: opacity .5s 1.8s;
}

.rossetto-menu__aside__social li{
  writing-mode: horizontal-tb;
  display: inline-block;
  margin: 0;
  & + li{
    margin-left: 1.5rem;
  }
  @include media(">=large"){
    writing-mode: vertical-rl;
    display: block;
    & + li{
      margin-left: 0;
      margin-top: 1.5rem
    }
  }
}
.rossetto-menu__aside__social a{
  font-size: 1.5rem;
  text-decoration: none;
  color: $white;
  transition: opacity .3s;
  &:hover{
    opacity: .75;
  }
  @include media(">=large"){
    writing-mode: vertical-rl;
  }
}

.rossetto-menu__navigation__button {
  display: flex;
  width: 100%;
  min-height: 2px;
  position: relative;
  line-height: 1;
  text-decoration: none;
  flex-direction: column;
  justify-content: space-between;
}

.rossetto-menu__navigation__button__bar {
  width: 100%;
  height: 2px;
  background-color: $white;
}

.rossetto-menu__navigation__button__extra-text {
  position: absolute;
  padding-right: 50px;
   transform: translateY(-50%);
   top: 50%;
  right: 0;
  @include media(">=xlarge"){
    padding-right: 60px;
  }
}

.rossetto-menu__navigation__button__bar--bottom {
  transform: translateY(-2px);
}

/* @group Morph Transition */
.menu-burger-enter {
  min-height: 20px;
}

.menu-burger-enter-to {
  min-height: 2px;
}

.menu-burger-leave {
  min-height: 0px;
}

.menu-burger-leave-to {
  min-height: 20px;
}

.menu-burger-enter-active {
  transition: all .8s;
}

.menu-burger-leave-active {
  transition: all .8s .8s;
}

.slide-burger-enter {
  opacity: 0;
}

.slide-burger-enter-to {
  opacity: 1;
}

.slide-burger-leave {
  opacity: 1;
}

.slide-burger-leave-to {
  opacity: 0;
}

.slide-burger-enter-active {
  transition: all .8s .8s;
}

.slide-burger-leave-active {
  transition: all .8s;
}
/* @end */
</style>
